import * as MUTATIONS from './mutation-types.js';
import defaultState from './state';
import { captureError } from "@/services/userMonitoring";

let newState = {};
Object.assign(newState, defaultState);

export const leadsModule = {
  state: newState,
  mutations: {
    [MUTATIONS.CLEAR]: (state) => { Object.assign(state, defaultState) },
    [MUTATIONS.SHOW_ARCHIVED_LEADS]: (state, value) => { state.SHOW_ARCHIVED_LEADS = value },
    [MUTATIONS.LEAD_ALERT_STATUS]: (state, value) => {state.LEAD_ALERT_STATUS = value},
    [MUTATIONS.ACTIVE_LEAD]: (state, value) => {state.ACTIVE_LEAD = value},
    [MUTATIONS.LEAD_ALERT_CONTROL]: (state, value) => {state.LEAD_ALERT_CONTROL = value},
    [MUTATIONS.LEAD_NOTIFICATION_INTERVAL]: (state, value) => {state.LEAD_NOTIFICATION_INTERVAL = value},
    [MUTATIONS.SELECTED_LEADS]: (state, leads) => {state.SELECTED_LEADS = [...leads]},
    [MUTATIONS.LEAD_NOTIFICATIONS]: (state, notifications) => {state.LEAD_NOTIFICATIONS = {...notifications}},
    [MUTATIONS.ADD_LEAD]: (state, lead) => {state.SELECTED_LEADS = [...state.SELECTED_LEADS, lead]},
    [MUTATIONS.CLEAR_SELECTED_LEADS]: (state) => {state.SELECTED_LEADS = []},
    [MUTATIONS.ACTIONED_LEADS]: (state, value) => {state.ACTIONED_LEADS = [...value]},
    [MUTATIONS.BULK_BUY]: (state, value) => {
      state.BULK_BUY = value;
      state.SELECTED_LEADS = [];
    },
    [MUTATIONS.AVAILABILITY_CHECK]: (state, value) => {state.AVAILABILITY_CHECK = value},
    [MUTATIONS.NOT_AVAILABLE]: (state, value) => {state.NOT_AVAILABLE = value},
    [MUTATIONS.PRE_SELECT]: (state, value) => {state.PRE_SELECT = value},
    [MUTATIONS.PRE_SELECT_REJECT]: (state, value) => {state.PRE_SELECT_REJECT = value},
    [MUTATIONS.ORIGIN]: (state, value) => {state.ORIGIN = value},
  },
  getters: {
    isInBasket: (state) => (lead) =>
      state.SELECTED_LEADS && state.SELECTED_LEADS.find(
      (selectedLead) => selectedLead[0].id === lead[0].id
      ) !== undefined
  },
  actions: {
    changeAlertStatus: async function({commit, dispatch}, value) {
      await this._vm.$api.leads.setLeadAlertStatus(value).then(() => {
        commit(MUTATIONS.LEAD_ALERT_STATUS, value);
        dispatch('getNotifications');
      }).catch(e => {
        commit(MUTATIONS.LEAD_ALERT_STATUS, !value);
        captureError(e, {
          section: "settings",
          action: "lead-alerts",
          type: "api-request",
        });
      });
    },
    leadAlertStatus: async function({commit}) {
      try {
        let response = await this._vm.$api.leads.getLeadAlertStatus();
        commit(MUTATIONS.LEAD_ALERT_STATUS, response.data.data.status);
        commit(MUTATIONS.LEAD_ALERT_CONTROL, response.data.data.control);
      }catch (e){
        captureError(e, {
            section: "settings",
            action: "lead-alerts",
            type: "api-request",
        });
      }
    },
    toggleLeadArchived: async function(object,id) {
      await this._vm.$api.leads.toggleLeadArchived(id);
    },
    addLeadToBasket: function(context, lead) {
      if (context.getters.isInBasket(lead)) {
        context.commit(
          MUTATIONS.SELECTED_LEADS,
          context.state.SELECTED_LEADS.filter((selectedLead) => selectedLead[0].id !== lead[0].id)
        );
      } else {
        context.commit(MUTATIONS.NOT_AVAILABLE, null);
        if (!context.state.BULK_BUY) {
          context.commit(MUTATIONS.CLEAR_SELECTED_LEADS);
          context.dispatch('checkAvailability', lead).then(() => {
            context.commit(MUTATIONS.AVAILABILITY_CHECK, false);
          }).catch((error) => {
            context.commit(MUTATIONS.AVAILABILITY_CHECK, false);
            if(error.response.data.errors) {
              context.commit(MUTATIONS.NOT_AVAILABLE, error.response.data.errors[0]);
            } else{
              context.commit(MUTATIONS.NOT_AVAILABLE, "This lead is not available");
            }
          });
        } else {
          if (context.state.SELECTED_LEADS.length >= 5) {
            return false;
          }
        }
        context.commit(MUTATIONS.ADD_LEAD,lead);
        return true;
      }
    },
    checkAvailability: async function({commit}, lead) {
      commit(MUTATIONS.AVAILABILITY_CHECK, true);
      return this._vm.$api.leads.checkAvailability(lead[0].id);
    },
    getLeadNotifications: async function(context) {
      if (!context.rootState.USER_STATE) {
        return;
      }
      this._vm.$api.leads.getLeadNotifications().then((response) => {
        let leads = response.data.data;
        Object.values(leads).forEach((group) => {
          Object.values(group).forEach(leadList => {
            leadList.forEach(lead => {lead.enquiry.sold = Math.max(lead.enquiry.sold, 0)});
          });
        });
        context.commit(MUTATIONS.LEAD_NOTIFICATIONS, leads);
      }).catch((e) => {
        captureError(e, {
          section: "polls",
          action: "lead-notifications",
          type: "api-request",
        });
      });
    },
    clearLeadNotifications: async function({dispatch}, {leads, callback}) {
      return this._vm.$api.leads.dismissLeadNotifications(leads)
        .then(() => {
          dispatch('getLeadNotifications').then(() => {
            callback();
          })
        })
        .catch(e => {
          captureError(e, {
            section: "polls",
            action: "lead-notifications",
            type: "api-request",
          });
        });
    },
    markLeadNotificationsRead: async function({dispatch}, leads) {
      return this._vm.$api.leads.markLeadNotificationsRead(leads).then(() => {
        dispatch('getLeadNotifications');
      })
    },
  }
};
